import { useMutation } from '@apollo/client';
import { Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomNotification } from 'src/components/custom-notification';
import YouTubeVideoCard from 'src/components/ui/youtube-videos/youtube-video-card';
import { ROUTES } from 'src/config/route';
import { YouTubeVideoForm } from 'src/lib/form-interfaces';
import { MutationCreateYouTubeVideo } from 'src/lib/gql/mutations';

const CreateYouTubeVideo = () => {
	const navigate = useNavigate();

	const [CreateYouTubeVideo] = useMutation(MutationCreateYouTubeVideo, {
		onError(error) {
			CustomNotification({
				pageName: 'YouTube Videos',
				pagePrefix: 'YouTube Video',
				notificationType: 'custom-error',
				customDescription: error.message,
			});
		},
	});

	const createQry = useCallback(async (data: YouTubeVideoForm) => {
		// Auto-generate thumbnail URL from video ID
		const thumbnailUrl = `https://img.youtube.com/vi/${data.videoId}/maxresdefault.jpg`;

		const rsp = await CreateYouTubeVideo({
			variables: {
				videoId: data.videoId,
				title: data.title,
				description: data.description || null,
				duration: data.duration,
				thumbnailUrl: thumbnailUrl,
				weight: data.weight ? parseInt(data.weight.toString()) : null,
				youTubeVideoHTags: data.tags || [],
			},
		});

		if (rsp.data) {
			CustomNotification({
				pageName: 'YouTube Video',
				pagePrefix: 'YouTube Video',
				notificationType: 'created',
			});

			navigate(`${ROUTES.EDIT_YOUTUBE_VIDEO.path}/${rsp.data.createYouTubeVideo?.id}`);
		}
	}, [CreateYouTubeVideo, navigate]);

	return (
		<Row>
			<Col span={24}>
				<Text className="sub-header">Create YouTube Video</Text>
			</Col>
			<Row style={{ width: '100%' }} gutter={16}>
				<YouTubeVideoCard onSave={createQry} />
			</Row>
		</Row>
	);
};

export default CreateYouTubeVideo;